export default __webpack_public_path__ + "static/media/icon_ig.77c61145.svg";